module.exports = __webpack_public_path__ + "static/media/login.aeae243f.svg";